<template>
    <div class="column right has-text-centered">
        <h1 class="title is-4">Recuperar contraseña</h1>
        <p class="description">Ingrese su correo para resetear su clave de acceso</p>
        <form @submit.prevent="submit">
            <div class="field">
                <div class="control">
                <input class="input is-medium" type="email" placeholder="Email" name="email" id="email" v-model="email">
                </div>
            </div>

            <button class="button is-block is-primary is-fullwidth is-medium">Resetear Clave</button>
            <br />
            <small class="has-text-danger"><em>{{errors}}</em></small>
            <small class="has-text-success"><em>{{message}}</em></small>
        </form>
    </div>                    
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'recover',
    created(){
        this.clearAuthErrors()
    },
    components: {
        //
    },
    computed: {
        ...mapGetters({
            errors: 'auth/errors'
        }),
    },    
    data(){
        return{
            message: '',
            email: ''
        }
    },
    methods:{
        ...mapActions({
            recover: 'auth/recover',
            clearAuthErrors: 'auth/clearAuthErrors',
        }),

        submit(){
            this.recover( { email: this.email} )
        }
    }
}
</script>
